/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export const APPROVAL_PREVIEW_INITIAL_CREATIVE_COUNT = 10;
export const APPROVAL_PREVIEW_MAX_CREATIVE_BATCH_SIZE = 10;

export function getApprovalPreviewCreativeBatchSize(remainingCount: number): number {
  return Math.min(APPROVAL_PREVIEW_MAX_CREATIVE_BATCH_SIZE, Math.max(0, remainingCount));
}

export function normalizeSiteIabCategories(model: any): void {
  model.iabCategories = _.map(model.iabCategories || [], (iab: any) => {
    return _.get(iab, ['id'], iab);
  });
}
